export enum CommercialArea {
  GWANAK = 'GWANAK',
  HONGDAE = 'HONGDAE',
  DONGDAEMUN = 'DONGDAEMUN',
  GANGNAM = 'GANGNAM',
  HYEHWA = 'HYEHWA',
  SEONGSU = 'SEONGSU',
}
